import { render } from "./CommentaryPanel.vue?vue&type=template&id=ff7ff2fe&scoped=true&ts=true"
import script from "./CommentaryPanel.vue?vue&type=script&lang=ts"
export * from "./CommentaryPanel.vue?vue&type=script&lang=ts"

import "./CommentaryPanel.vue?vue&type=style&index=0&id=ff7ff2fe&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7ff2fe"]])

export default __exports__